function ajioWalletData(state = {}, action) {
  switch (action.type) {
    case 'SET_AJIOWALLET_DATA':
      return { ...state, ajioWalletBalanceDet: action.ajioWalletData };
    case 'GET_AJIOWALLET_DATA_SUCCESS':
      return { ...state, success: action.success };
    case 'GET_AJIOWALLET_DATA_FAIL':
      return { ...state, success: action.success };
    case 'SET_AJIOWALLET_TXN_DATA':
      return { ...state, ajioWalletTxnData: action.ajioWalletTxnData };
    case 'GET_AJIOWALLET_TXN_DATA_SUCCESS':
      return { ...state, success_txn_data: action.success_txn_data };
    case 'GET_AJIOWALLET_TXN_DATA_FAIL':
      return { ...state, success_txn_data: action.success_txn_data };
    case 'SET_AJIOWALLET_EARN_DATA':
      return { ...state, ajioWalletEarnData: action.ajioWalletEarnData };
    case 'SET_AJIOWALLET_BURN_DATA':
      return { ...state, ajioWalletBurnData: action.ajioWalletBurnData };
    case 'SET_AJIOWALLET_EARN_AMOUNT':
      return { ...state, ajioWalletEarnAmount: action.ajioWalletEarnData };
    case 'SET_AJIOWALLET_FAQS':
      return { ...state, faqs: action.ajioWalletFaqs };
    default:
      return state;
  }
}

export default ajioWalletData;
